module.exports = __webpack_public_path__ + "img/Grouphover.695205c4.svg";